/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactNote
 */
export interface ContactNote {
    /**
     * 
     * @type {string}
     * @memberof ContactNote
     */
    contactNoteId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactNote
     */
    topics?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ContactNote
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactNote
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the ContactNote interface.
 */
export function instanceOfContactNote(value: object): value is ContactNote {
    return true;
}

export function ContactNoteFromJSON(json: any): ContactNote {
    return ContactNoteFromJSONTyped(json, false);
}

export function ContactNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactNote {
    if (json == null) {
        return json;
    }
    return {
        
        'contactNoteId': json['contactNoteId'] == null ? undefined : json['contactNoteId'],
        'topics': json['topics'] == null ? undefined : json['topics'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function ContactNoteToJSON(json: any): ContactNote {
    return ContactNoteToJSONTyped(json, false);
}

export function ContactNoteToJSONTyped(value?: ContactNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactNoteId': value['contactNoteId'],
        'topics': value['topics'],
        'subject': value['subject'],
        'createdAt': value['createdAt'],
    };
}

